import { Avatar, ClassNameMap } from "@mui/material";
import { SxProps, Theme } from "@mui/material/styles";
import { CSSProperties } from "react";

interface Props {
  /**
   * Image url
   */
  avatarUrl: string;
  /**
   * sx prop of the Avatar component
   */
  sx?: SxProps<Theme>;
  /**
   * if `true`, only displays a generic local image
   */
  forceGenericAvatar?: boolean;
  /**
   * provide a generic avatar to use in case of no image present
   * a JSX element is expected
   * it can receive and image or a icon component for example
   * if forceGenericAvatar is true but this element is missing
   * a standard 'person icon' will be loaded
   */
  genericAvatar?: JSX.Element;
  /**
   * provide a generic placeholder to use in case of no image present and no genericAvatar forced.
   * if this property does not exist either, N/A text will be used as placeholder
   */
  genericPlaceholder?: string;

  customStyle?: CSSProperties;

  customClasses?: string;

  onClick?: () => void;
}

export default function OpsAvatarComponent(props: Props) {
  const date = new Date();
  return props.avatarUrl ? (
    <Avatar style={{ ...props.customStyle }} sx={props.sx} src={`${props.avatarUrl}?date=${date}`} className={props.customClasses} onClick={props.onClick}/>
  ) : props.forceGenericAvatar ? (
    props.genericAvatar ? (
      <Avatar style={{ ...props.customStyle }} sx={props.sx} onClick={props.onClick}>
        {" "}
        {props.genericAvatar}{" "}
      </Avatar>
    ) : (
      <Avatar style={{ ...props.customStyle }} sx={props.sx} onClick={props.onClick}/>
    )
  ) : (
    <Avatar style={{ ...props.customStyle }} sx={props.sx} onClick={props.onClick}>
      {props.genericPlaceholder ? props.genericPlaceholder : "N/A"}
    </Avatar>
  );
}
